import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import UPM from '../constants/urlPermissionMappings';
import * as AppUrl from '../constants/appUrl';
import auth from '../utils/auth';
import { inject, observer } from 'mobx-react';
import { ConfigProvider } from 'antd'
import history from '../routes/history';
import { Env } from '../constants/appConstant';

@inject('accountStore')
@observer
class PrivateRoute extends Component {
  urlPathMatch = (url, path) => {
    // 处理带参数的路由匹配
    if (url.includes(':')) {
      // 将参数路由转换为正则表达式
      const regexPattern = url.replace(/:[^/]+/g, '[^/]+');
      const regex = new RegExp(`^${regexPattern}$`);
      return regex.test(path);
    }
    // 原有的精确匹配
    return url.toLowerCase().split('?')[0] === path.toLowerCase();
  };
  checkPermission = pathname => {
    const upm = UPM.find(item => this.urlPathMatch(item.url, pathname));
    if (!upm) return false;
    if (upm.ignore) return true;
    const authorizedKeys = auth.getPermissions();
    return authorizedKeys?.includes(upm.pKey || '');
  };
  redirectLogin() {
		// if(Env !== 'local'){
    //   window.location.href=`${window.g.ssoLoginUrl}`
    // } else {
			history.push('/login');
		// }
  }
  render() {
    const { component: RComponent, ...rest } = this.props;
    const isAuthorized = auth.isAuthorized();
    const permissions = auth.getPermissions();
    const redirectUrl = permissions?.includes('home') ? AppUrl.HOME : (permissions?.[0] || AppUrl.HOME);
    return (
      <ConfigProvider>
        <Route
          {...rest}
          render={routeProps =>
            !isAuthorized ?
              this.redirectLogin() :
              this.checkPermission(routeProps.location.pathname) ?
                (<RComponent {...routeProps} />) :
                (<Redirect to={redirectUrl}/>)
          }
        />
      </ConfigProvider>
    );
  }
}

export default PrivateRoute;
